import styles from '../src/scss/main.scss';
import 'simplebar';

import './js/jquery.arcticmodal-0.3.min.js';
import './js/main';
